<template>
  <ul class="tournaments-list grid grid-gap grid-2-columns@sm grid-3-columns@md list-plain">
    <li v-for="tournament in tournaments" :key="tournament.address" class="flex">
      <RouterLink
        :to="{
          name: 'TournamentsSingleRound',
          params: {
            tournamentAddress: tournament.address,
            roundId: tournament.round.index + 1
          }
        }"
        class="flex-grow flex"
      >
        <MtxCard
          class="tournaments-item flex-grow flex flex-column text-center"
          :class="`tournaments-item--${tournament.round.status}`"
        >
          <div class="flex-grow text-center mb-2">
            <small class="tournaments-item__status px-1 mb-2">
              {{ tournament.round.status | capitalize }}
            </small>

            <div class="mb-2">
              <span class="heading-5 mb-0 flex align-center justify-center">
                <MtxSvg icon="icon-trophy" class="mr-1" />
                {{ tournament.round.bounty | mtx }}
              </span>
              <small class="tournaments-item__total">of {{ tournament.bounty | mtx }}</small>
            </div>

            <h3 class="heading-4 break-word">{{ tournament.title | truncate(100) }}</h3>
          </div>

          <div class="flex flex-wrap justify-between align-center">
            <span>
              <MtxSvg v-if="tournament.round.totalParticipants === 1" icon="icon-person" />
              <MtxSvg v-else icon="icon-people" />
              {{ tournament.round.totalParticipants }}
            </span>
            <span>
              <MtxSvg icon="icon-file" />
              {{ tournament.round.totalSubmissions }}
            </span>
            <span>
              <MtxSvg icon="icon-timelapse" />
              <time :datetime="tournament.round.endDate">
                {{ tournament.round.endDate | date("MMM Do, YYYY") }}
              </time>
            </span>
          </div>

          <!-- <p>{{ t.description | truncate(110) }}</p> -->
        </MtxCard>
      </RouterLink>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    tournaments: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
.tournaments-item {
  border-left: rem(4px) solid;
  border-bottom: rem(4px) solid;

  &--scheduled,
  &--scheduled &__status,
  &--review,
  &--review &__status {
    border-color: $yellow;
  }

  &--open,
  &--open &__status {
    border-color: $green;
  }

  &--closed,
  &--closed &__status {
    border-color: $red;
  }

  &--abandoned,
  &--abandoned &__status {
    border-color: $grey;
  }

  &__status {
    display: inline-block;
    border-bottom: rem(2px) solid;
    padding-bottom: rem(2px);
    font-weight: 700;
  }

  &__total {
    display: block;
  }
}
</style>
